import React from 'react';
import { observer } from 'mobx-react';

import LinkView from 'lib/ui/link-view';
import Styled from 'styled';
import Localizable from 'lib/intl/localizable';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';

import { displayedName } from 'four-nets/user/utils';
import VerticalSeparatorView from 'four-nets/ui/vertical-separator-view';
import { Review } from 'four-nets/bazaar/bazaar';

import defaultStyles from 'four-nets/common/comment/comment-header/comment-header-view.scss';
import verticalSeparatorStyles from 'four-nets/common/comment/comment-header/vertical-separator-view.scss';
import { Link } from 'react-router-dom';

export interface Props {
    styles: typeof defaultStyles;
    review: Review;
    commentHeaderViewModel: any;
}

@Localizable()
@observer
class CommentHeaderView extends React.Component<Props> {
    render() {
        const { styles, commentHeaderViewModel } = this.props;
        const { comment, vendorLink } = commentHeaderViewModel;
        const { user } = comment;

        return (
            <div className={styles.commentHeader}>
                <div className={styles.userWrapper}>
                    <div className={styles.linkWrapper}>
                        {!user.isAnonymous ? (
                            <Link to={`/blog/${user.username}/`} className={styles.user}>
                                {displayedName(user)}
                            </Link>
                        ) : (
                                <p className={styles.user}>{user.username}</p>
                            )}
                        {vendorLink ? (
                            <div>
                                <LinkView link={vendorLink} className={styles.user} />
                                {user.dateJoined ? <VerticalSeparatorView styles={verticalSeparatorStyles} /> : null}
                            </div>
                        ) : null}
                    </div>
                </div>
                <FormattedDateAgoView value={comment.time} />
            </div>
        );
    }
}

export default Styled(defaultStyles)(CommentHeaderView);
